import Vue from 'vue'
import TimeMe from '../plugins/timeme.min.js'
import { mapState } from 'vuex'

import analyticEvents from '@/services/analyticEvents'

const TimeTrackerMixin = Vue.extend({
  data() {
    return {
      timeOnPage: 0,
      timeOnEvent: 0,
      pageName: '',
    };
  },
  computed: {
    ...mapState({
      userId: (state: any) => state.userData.user.id,
      schoolId: (state: any) => state.userData.user?.school?.id,
    }),
  },
  mounted() {
    this.pageName = this.$options.name || 'UnnamedPage'
    this.startEvent(this.pageName)
  },
  methods: {
    initializeTimeTracking() {
      TimeMe.initialize({
        idleTimeoutInSeconds: 120,
      })
    },
    startEvent(eventName: string) {
      this.initializeTimeTracking()
      TimeMe.setCurrentPageName(this.pageName)
      TimeMe.startTimer(eventName)
    },
    endEvent(eventName: string) {
      TimeMe.stopTimer(eventName)
      this.timeOnEvent = TimeMe.getTimeOnPageInSeconds(eventName) ?? 0
    },
    async updateTimeOnPage() {
      try {
        TimeMe.stopTimer(this.pageName)
        this.timeOnEvent = TimeMe.getTimeOnPageInSeconds(this.pageName) ?? 0
        await analyticEvents.updateEventDuration({ user_id: this.userId, duration_in_seconds: this.timeOnEvent })

        TimeMe.resetRecordedPageTime(this.pageName)
      } catch (error) {
        console.error(error)
      }
    },
  },
  async beforeDestroy() {
    TimeMe.stopAllTimers()
    await this.updateTimeOnPage()
  },
})

export default TimeTrackerMixin
